<script>
export default {
  page: {
    title: 'Style Guide',
  },
  methods: {
    showToast({ toastClass, longMessage = false }) {
      const toastMessage = longMessage
        ? 'A password reset link has just been sent to both your Motto and personal email addresses.'
        : 'Server Error. Please try again in a few moments.'
      this.$bvToast.toast(toastMessage, {
        toaster: 'b-toaster-bottom-center',
        toastClass: toastClass,
        noAutoHide: true,
      })
    },
  },
}
</script>

<template>
  <div>
    <div class="col my-3">
      <h1>Brand Standards</h1>
    </div>
    <div class="col">
      <h2 class="my-3">Typography</h2>
      <div class="mt-1 row">
        <div class="col-3">
          <h1>H1 - 32px</h1>
          <h2>H2 - 24px</h2>
          <h3>H3 - 18px</h3>
          <h4>H4 - 16px</h4>
        </div>
        <div class="col-3">
          <p class="p1">P1 - 14px</p>
          <p class="p2">P2 - 12px</p>
          <p class="button-text">Button - 14px</p>
          <p class="overline-text">Overline - 12px</p>
          <p class="tag-text">Tag - 12px</p>
        </div>
      </div>
    </div>
    <div class="col">
      <h2 class="my-3">Toasts</h2>
      <button @click.prevent="showToast({ toastClass: 'toast-error' })">Error Toast</button>
      <button @click.prevent="showToast({ toastClass: 'toast-error', longMessage: true })">Error Toast - Long</button>
      <button @click.prevent="showToast({ toastClass: 'toast-warning' })">Warning Toast</button>
      <button @click.prevent="showToast({ toastClass: 'toast-warning', longMessage: true })">
        Warning Toast - Long
      </button>
      <button @click.prevent="showToast({ toastClass: 'toast-success' })">Success Toast</button>
      <button @click.prevent="showToast({ toastClass: 'toast-success', longMessage: true })">
        Success Toast - Long
      </button>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
